import ReactPixel from 'react-facebook-pixel';
import { useCallback, useEffect } from 'react';

export const CURSEDUCA_PIXEL_ID = '837834646732115';

let isInitialized = false;

const ensureInitialized = () => {
	if (isInitialized) return;

	ReactPixel.init(CURSEDUCA_PIXEL_ID);
	isInitialized = true;
};

export const useCurseducaPixel = (enabled: boolean) => {
	useEffect(() => {
		if (!enabled) return;

		ensureInitialized();
	}, [enabled]);

	// trackSingle, not track: the tenant pixel may also be initialized on this
	// page and fbq('track') fires on every initialized pixel.
	const track = useCallback(
		(event: string, data?: unknown) => {
			if (!enabled) return;

			ensureInitialized();
			ReactPixel.trackSingle(CURSEDUCA_PIXEL_ID, event, data);
		},
		[enabled]
	);

	return { track };
};
